import { render } from "./ScrollVue.vue?vue&type=template&id=5655ff26"
import script from "./ScrollVue.vue?vue&type=script&lang=js"
export * from "./ScrollVue.vue?vue&type=script&lang=js"

import "./ScrollVue.vue?vue&type=style&index=0&id=5655ff26&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__